export default function handle401(apiCall) {
  return async () => {
    try {
      const response = await apiCall();

      return response;
    } catch (e) {
      if (e.status === 401) {
        return null;
      } else {
        throw e;
      }
    }
  };
}
